import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {BaseWelcomeComponent} from '@catapp/shared/feature/create-form-wizards/base-welcome.component';
import { ProjectService} from '@catcore/services';
import {EntitySchemaService} from '@catcore/services/entity-schema.service';
import {Project} from '@catcore/types/api-v2';
import {sortByLabelFunc} from '@catcore/utils';
import {EntitySchemaType} from '@catcore/utils/json-schema/entity-schema-to-json-schema';
import {ProjectAvodCatalogService} from '@catmodels/avod-catalog/services/project-avod-catalog.service';
import {SelectItem} from 'primeng/primeng';
import {Subscription} from 'rxjs';
import {isNullOrUndefined} from 'util';

@Component({
  selector: 'cat-project-avod-catalog-create',
  templateUrl: './project-avod-catalog-create.component.html',
  styleUrls: ['./project-avod-catalog-create.component.scss'],
})
export class ProjectAvodCatalogCreateComponent extends BaseWelcomeComponent {

  /**
   * The self-name to be used throughout the displayed elements.
   * Reference to the current used type of model
   * @type {string}
   */
  selfLabel = 'Project AVoD Catalog';

  /**
   * The title used by the form wizard component
   * @type {string}
   */
  title = `New ${this.selfLabel}`;
  resetAfterComplete = true;

  // selection values
  avodCatalogServiceOptions: SelectItem[];
  modeOptions: SelectItem[];

  labels = {
    name: 'Name',
    avodCatalogService: 'AVoD Catalog Service',
    mode: 'Mode',
    rootPath: 'Root Path',
    removableMedia: 'Removable Media',
    trackRemoves: 'Track Removes',
    buttons: {last: `Save the ${this.selfLabel}`},
  };

  @Output() success = new EventEmitter<boolean>();

  private projectSchema = null;
  private project: Project;
  private projectSubscription: Subscription;

  // default values
  private throttle = 'idle';
  private locationId = 0;
  private lowWaterMark = 30;
  private triggerFile = null;
  private baseURL = '';
  private additionalPaths = '';

  get formIsReady() {
    let isReady = !isNullOrUndefined(this.project);
    isReady = isReady && !isNullOrUndefined(this.form);
    isReady = isReady && !isNullOrUndefined(this.projectSchema);
    return isReady;
  }

  constructor(private projectAvodCatalogService: ProjectAvodCatalogService,
              private projectService: ProjectService,
              private schemaService: EntitySchemaService) {
    super();

    this.projectSchema = schemaService.getForEntityName(EntitySchemaType['ProjectAvodCatalogs']);
    this.projectSubscription = this.projectService.getCurrentProject().subscribe((project) => {
      this.project = project;
    });
    this.form = new FormGroup({
      name: new FormControl('', [Validators.required]),
      avodCatalogService: new FormControl(null, [Validators.required]),
      mode: new FormControl(null, [Validators.required]),
      rootPath: new FormControl('', [Validators.required]),
      removableMedia: new FormControl(false, []),
      trackRemoves: new FormControl(false, []),
    });
  }

  beforeDisplayProperties() {
    if (!isNullOrUndefined(this.project)) {
      this.projectService
        .getAllServices(this.project, 'AVODCatalog').subscribe((services: any[]) => {
        this.updateAvodCatalogServiceOptions(services);
      });
    }
    if (this.projectSchema) {
      this.modeOptions = this.updateChoicesOptions(this.projectSchema.properties.mode.choices);
    }
  }

  saveNewEntity() {
    this.projectAvodCatalogService
      .create({
        name: this.form.value.name,
        service: this.form.value.avodCatalogService,
        mode: this.form.value.mode,
        throttle: this.throttle,
        locationId: this.locationId,
        lowWaterMark: this.lowWaterMark,
        triggerFile: this.triggerFile,
        baseURL: this.baseURL,
        rootPath: this.form.value.rootPath,
        additionalPaths: this.additionalPaths,
        removableMedia: this.form.value.removableMedia,
        trackRemoves: this.form.value.trackRemoves,
      })
      .subscribe((catalog) => {
        this.setCurrentEntity(catalog);
        this.setIsCompleted(catalog !== null);
        if (!isNullOrUndefined(catalog)) {
          this.success.emit(true);
        } else {
          this.success.emit(false);
        }
      });
  }

  modeChanged($event) {
    if ((this.form.value.mode === 'tracker') && !this.form.value.removableMedia ) {
      this.form.patchValue({rootPath: '/mnt/private_media'});
      this.triggerFile = '.metainfo.dat';
    } else if (this.form.value.mode === 'mpu') {
      this.form.patchValue({
        root_path: '/mnt/protected_media',
        removable_media: false,
      });
      this.triggerFile = 'mpu.xml';
    }
  }

  removableMediaChanged($event) {
    if (this.form.value.removableMedia) {
      this.form.patchValue({rootPath: '/mnt/usb'});
      this.triggerFile = '.metainfo.dat';
    } else {
      this.modeChanged(null);
    }
  }

  validatePropertiesView() {
  }

  getServiceName(service: any): string {
    return service.label;
  }

  private updateOptionsList(items: any[]) {
    const optionList = [];
    items.forEach((item) => {
      optionList.push({label: item.label, value: item});
    });
    optionList.sort(sortByLabelFunc);
    return optionList;
  }

  private updateAvodCatalogServiceOptions(items: any[]) {
    const services = items.filter( (service) => {
      return service['name'] === 'AVODCatalog';
    });
    this.avodCatalogServiceOptions = this.updateOptionsList(services);
  }

  /**
   * Update the available GUI zone types
   *
   * @param {string[]} choices
   */
  private updateChoicesOptions(choices: string[]) {
    const items: SelectItem[] = [];
    choices.forEach((name: string) => items.push({label: name, value: name}));
    return items;
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/models/avod-catalog/components/project-avod-catalog-create/project-avod-catalog-create.component.ts